<div>
  @if(hideMenu === false){
  <app-dashboard-bar [calculationType]="calcResults?.calculationType" (languageDidChange)="languageDidChange($event)"
    (downloadPDFPressed)="downloadPressed()" [reportType]="reportType"
    (reportTypeDidChange)="reportTypeDidChange($event)"></app-dashboard-bar>
  }
</div>
<div class="max-w-comfort mt-4" [style.paddingTop]="hideMenu ? '0px' : '110px'">
  <div class="flex justify-content-center align-items-center h-screen"
    *ngIf="currentDashboardState.stateType === DashboardStateType.LOADING">
    <p-progressSpinner [style]="{ width: '50px', height: '50px' }" strokeWidth="4"> </p-progressSpinner>
  </div>
  <app-myopia-single-dashboard *ngIf="currentDashboardState.stateType === DashboardStateType.SINGLE_MYOPES"
    [calculationResults]="calcResults!" [reportType]="reportType" [patientName]="patientName"></app-myopia-single-dashboard>
  <app-premyopia-dashboard *ngIf="currentDashboardState.stateType === DashboardStateType.PREMYOPES"
    [calculationResults]="calcResults!" [reportType]="reportType" [patientName]="patientName"></app-premyopia-dashboard>
  <app-myopia-progression-dashboard *ngIf="currentDashboardState.stateType === DashboardStateType.MYOPES_PROGRESSION"
    [calculationResults]="calcResults!" [reportType]="reportType" [patientName]="patientName"></app-myopia-progression-dashboard>
  <app-no-calc-dashboard *ngIf="currentDashboardState.stateType === DashboardStateType.NO_CALC"
    [calculationResults]="calcResults!" [reportType]="reportType" [patientName]="patientName"></app-no-calc-dashboard>
</div>